import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Fronteira de erro para capturar exceções não tratadas em subárvores React
 * e evitar a tela branca. Mostra uma mensagem amigável com botão de recarregar.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log detalhado no console para debug em produção
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Erro capturado:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-[50vh] flex items-center justify-center p-6"
      >
        <div className="max-w-md w-full border border-destructive/30 bg-destructive/5 rounded-sm p-6 space-y-4">
          <div className="flex items-center gap-3">
            <AlertTriangle size={24} className="text-destructive" />
            <div>
              <div className="label-tag text-destructive">Falha inesperada</div>
              <h2 className="font-heading font-bold text-lg mt-1">Algo travou nesta tela</h2>
            </div>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Um erro impediu esta seção de renderizar. Seus dados no servidor estão seguros —
            apenas esta tela precisa ser recarregada.
          </p>
          {this.state.error?.message && (
            <div className="text-xs font-mono bg-background border border-border p-2 rounded-sm break-anywhere">
              {String(this.state.error.message).slice(0, 240)}
            </div>
          )}
          <div className="flex gap-2">
            <Button onClick={this.handleReset} variant="outline" size="sm" className="flex-1 rounded-sm">
              Tentar novamente
            </Button>
            <Button onClick={this.handleReload} size="sm" className="flex-1 rounded-sm bg-foreground text-background hover:bg-foreground/90">
              <RefreshCw size={12} className="mr-2" /> Recarregar página
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
